export * from './tabs.module';
export * from './animations/animations';
